/**
 * Dependencies.
 */
import de from './de';
import en from './en';
import es from './es';
import it from './it';
import pt from './pt';

/**
 * Export translations.
 */
export default {
  'de-DE': { TRACKING_OLD: de },
  'en-US': { TRACKING_OLD: en },
  'es-ES': { TRACKING_OLD: es },
  'it-IT': { TRACKING_OLD: it },
  'pt-PT': { TRACKING_OLD: pt }
};
